import { XingletWrapper } from './xinglet-helpers';
import type { XingletInterface } from './xinglet-helpers';

export type PreviewProps = {
  pageVisible?: number;
  setTotalPages?: (total: number) => void;
  className?: string;
  onOpenPreview?: () => void;
};

export type PreviewXinglet = XingletInterface<PreviewProps>;
export const Preview = XingletWrapper<PreviewProps>(
  '@xing-com/crate-lebenslauf-components-preview'
);
